import React, { useCallback, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react'
import CreatableSelect from 'react-select/creatable';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { useDispatch, useStore } from 'react-redux'
import { Loader, Modal } from 'rsuite';
import 'react-phone-input-2/lib/style.css'
import { Link } from "react-router-dom"

import { updateSupplierBasicInfo, addSupplierHistory, checkEmployerIdNumberExists, getAllParentOrganizations, createParentOrganizations } from '../../../../redux/actions/vendor'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { generateSupplierBasicInfoChangeLog, checkIsPhoneNumberValid, checkIsEmailValid, getAbbreviatedState, getParsedAddress, checkZip, convertAddress } from '../../../../services/helper'
import { parseFullAddress } from '../../../../redux/actions/upload'
import ContactView from '../../../ContactsComponent/contactView'
import AllContacts from '../../../ContactsComponent/allContacts'
import { getExistingContacts } from '../../../../redux/actions/contact'
import LoaderComponent from '../../../CommonComponents/LoaderComponent';

const SupplyInformation = forwardRef(({ masterSupplierId, onUpdateCompletenessScore = () => { }, onInfoChange, onCreateContact, onGetAllContactsData }, ref) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const basicInfoSaveRef = useRef(null)
  const {
    vendor: {
      masterSupplierDetails,
    },
    app: {
      masterSupplierColumns
    }
  } = store

  useImperativeHandle(ref, () => ({
    onCreateContactForEmailPhone,
    handleSaveSupplierInfo
  }))

  const [supplierInfo, setSupplierInfo] = useState({})
  const [supplierOldInfo, setSupplierOldInfo] = useState({})
  const [isPhoneValid, setIsPhoneValid] = useState('')
  const [isNaicsValid, setIsNaicsValid] = useState(true)
  const [isSicValid, setIsSicValid] = useState(true)
  const [isValidatingPhone, setIsValidatingPhone] = useState(false)
  const [countryCode, setCountryCode] = useState('')
  const [isEmailValid, setIsEmailValid] = useState('')
  const [isValidatingEmail, setIsValidatingEmail] = useState(false)
  const [isEmailRisky, setIsEmailRisky] = useState("")
  const [showEinModal, setShowEinModal] = useState(false)
  const [supplierExistWithEIN, setSupplierExistWithEIN] = useState({})
  const [isParsingAddress, setIsParsingAddress] = useState(false)
  const [showAllContacts, setShowAllContacts] = useState({
    email: false,
    phone: false
  })
  const [existedContacts, setExistedContacts] = useState([])
  const [allContacts, setAllContacts] = useState([])
  const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
  const [currentContact, setCurrentContact] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [organizationOptions, setOrganizationOptions] = useState([]);

  useEffect(() => {
    if (masterSupplierDetails?.baseInfo?.parentOrganizationId) {
      const newOption = {
        label: masterSupplierDetails?.baseInfo?.parentOrganization,
        value: masterSupplierDetails?.baseInfo?.parentOrganizationId,
      };
      setSelectedOrganization(newOption);
    }
  }, [masterSupplierDetails]);


  const fetchParentOrganizations = async (inputValue = '') => {
    setIsLoading(true);
    try {
      const response = await dispatch(getAllParentOrganizations(inputValue));
      const options = response.map((org) => ({
        label: org.name,
        value: org.id,
      }));
      setOrganizationOptions(options);
    } catch (error) {
      console.error('Error fetching parent organizations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseEINExistModal = () => {
    setShowEinModal(false)
  }

  const handleChangeSupplierInfo = (colName, value, event) => {
    let tmpValue = value
    if (colName === 'state' || colName === 'country') {
      if (/^[a-zA-Z\s]+$/.test(value)) {
        tmpValue = value
      } else {
        tmpValue = value.match(/^[a-zA-Z\s]+/gi) ? value.match(/^[a-zA-Z\s]+/gi)[0] : ''
      }
    } else if (colName === 'phone') {
      tmpValue = value
      setIsPhoneValid(false)
    } else if (colName === 'zip') {
      if (/^\d{5}(-\d{4})?$/.test(value)) {
        tmpValue = value
      } else {
        tmpValue = value.match(/^\d{1,5}(-\d{0,4})?/gi) ? value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
      }
    } else if (colName === 'naics') {
      tmpValue = value
      if (value === '' || /^(\d{5}|\d{6})?$/i.test(value)) {
        setIsNaicsValid(true)
      } else {
        setIsNaicsValid(false)
      }
    } else if (colName === 'sic') {
      tmpValue = value
      if (value === '' || /^\d{4}?$/i.test(value)) {
        setIsSicValid(true)
      } else {
        setIsSicValid(false)
      }
    } else if (colName === 'email') {
      if (!tmpValue) {
        setIsEmailValid(true)
        setIsEmailRisky('')
      } else {
        setIsEmailValid(false)
        setIsEmailRisky('')
      }
    } else if (colName === 'phoneExtension') {
      if (/^\d{20}$/.test(value)) {
        tmpValue = value
      } else {
        tmpValue = value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
      }
    } else if (colName === 'employerIdNumber') {
      if (value.length === 3 && value.includes('-')) {
        value = value.replaceAll('-', '')
      } else if (value.length === 2 || value.length === 3) {
        if (value.length === 3) {
          value = value.substring(0, 2) + '-' + value.substring(2)
        } else {
          value += '-'
        }
      }
      if (/^\d{2}(-\d{7})?$/.test(value)) {
        tmpValue = value
      } else {
        tmpValue = value.match(/^\d{1,2}(-\d{0,7})?/gi) ? value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
      }
    } else if (colName === 'abbreviatedState') {
      let regex = /^[a-zA-Z\s]{2}$/
      let regex1 = /^[a-zA-Z\s]{1,2}/gi
      if (supplierInfo?.country && (supplierInfo?.country.trim().toLowerCase() === 'australia' || supplierInfo?.country.trim().toLowerCase() === 'aus')) {
        regex = /^[a-zA-Z\s]{3}$/
        regex1 = /^[a-zA-Z\s]{1,3}/gi
      }
      if (regex.test(value)) {
        tmpValue = value.trim().toUpperCase()
      } else {
        tmpValue = value.trim().match(regex1) ? value.trim().match(regex1)[0].toUpperCase() : ''
      }
      supplierInfo.state = tmpValue
    }

    setSupplierInfo({
      ...supplierInfo,
      [colName]: tmpValue,
    })
    onInfoChange(true)
  }

  const checkEINExistOrNot = async () => {
    if (supplierInfo?.employerIdNumber && supplierInfo?.employerIdNumber !== '' && !/^(\d{2}-\d{7})?$/.test(supplierInfo?.employerIdNumber)) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx!'
      })
      return
    }

    if (supplierOldInfo?.employerIdNumber === supplierInfo?.employerIdNumber) {
      handleSaveSupplierInfo()
      return;
    }


    const isEINExists = await dispatch(checkEmployerIdNumberExists({
      employerIdNumber: supplierInfo.employerIdNumber,
      getEINData: true
    }))

    if (isEINExists?.einCount && isEINExists?.einCount > 0) {
      setShowEinModal(true)
      setSupplierExistWithEIN(isEINExists.einResult[0])
    } else {
      setSupplierExistWithEIN({})
      handleSaveSupplierInfo()
    }
  }

  const handleSaveSupplierInfo = async () => {
    setIsLoading(true)
    const tmpsupplierInfo = { ...supplierInfo }
    const tmpsupplierOldInfo = { ...supplierOldInfo }
    delete tmpsupplierInfo.employerIdNumber;
    delete tmpsupplierOldInfo.employerIdNumber;

    var isEINChanged = false
    if (countryCode === supplierInfo?.phone) {
      supplierInfo['phone'] = ''
    }

    if (isValidatingPhone) {
      toast.show({
        title: 'Warning',
        description: 'validating phone number...!',
      })
      setIsLoading(false)
      return
    }
    if (isValidatingEmail) {
      toast.show({
        title: 'Warning',
        description: 'validating email...!',
      })
      setIsLoading(false)
      return
    }

    if (!isEmailValid && isEmailValid !== '') {
      toast.show({
        title: 'Warning',
        description: 'Invalid Email'
      })
      setIsLoading(false)
      return
    }
    if (isPhoneValid === false) {
      toast.show({
        title: 'Warning',
        description: 'Invalid Phone Number.'
      })
      setIsLoading(false)
      return
    }

    if (!isNaicsValid) {
      toast.show({
        title: 'Warning',
        description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long.'
      })
      setIsLoading(false)
      return
    }

    if (!isSicValid) {
      toast.show({
        title: 'Warning',
        description: 'Invalid SIC Code. Must be atleast 4 digits long.'
      })
      setIsLoading(false)
      return
    }


    if (supplierInfo?.address1) {
      let address = convertAddress(supplierInfo?.address1)
      supplierInfo.address1 = address
    }

    if (supplierInfo?.zip) {
      let validZip = checkZip(supplierInfo?.zip)
      if (!validZip) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Zip',
        })
        setIsLoading(false)
        return
      }
    }

    if (supplierInfo?.abbreviatedState && supplierInfo?.abbreviatedState !== '') {
      let regex = /^[a-zA-Z\s]{2}$/
      let stateChars = 2
      if (supplierInfo?.country && (supplierInfo?.country.trim().toLowerCase() === 'australia' || supplierInfo?.country.trim().toLowerCase() === 'aus')) {
        regex = /^[a-zA-Z\s]{2,3}$/
        stateChars = '2 or 3'
      }
      if (!regex.test(supplierInfo?.abbreviatedState.trim())) {
        toast.show({
          title: 'Warning',
          description: 'Invalid State. Must be ' + stateChars + ' characters long!'
        })
        setIsLoading(false)
        return
      }
    }

    let tmpData = { ...supplierInfo }
    if (supplierExistWithEIN?.id) {
      tmpData.employerIdNumber = null
    } else {
      tmpData.employerIdNumber = supplierInfo.employerIdNumber !== "" ? supplierInfo.employerIdNumber : null
    }

    if (supplierOldInfo?.employerIdNumber && supplierOldInfo?.employerIdNumber !== '' && supplierOldInfo?.employerIdNumber !== supplierInfo?.employerIdNumber) {
      isEINChanged = true;
    }

    if (selectedOrganization) {
      tmpData.parentOrganizationId = selectedOrganization?.value
      tmpData.parentOrganization = selectedOrganization?.label
    }
    await dispatch(
      await updateSupplierBasicInfo({
        supplierId: masterSupplierDetails?.baseInfo?.id,
        basicData: {
          ...masterSupplierDetails?.baseInfo,
          ...tmpData,
        },
        isEINChanged
      })
    ).then(async () => {
      onGetAllContactsData()
      onInfoChange(false)
      await addSupplierBasicInfoHistory()
      onUpdateCompletenessScore(masterSupplierDetails?.baseInfo?.id)
      setIsLoading(false)
    })

    setShowEinModal(false)
    setSupplierExistWithEIN({})
  }

  const handleCancelSupplierInfo = () => {
    setInitialSupplierInfo(masterSupplierColumns, masterSupplierDetails)
  }

  const setInitialSupplierInfo = useCallback(async (columns, supplierDetails) => {
    let supplierColumns = [...columns]
    supplierColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
    const tmpSupplierInfo = {}
    const usArray = ['united states', 'usa', 'us']
    supplierColumns.forEach(column => {
      const tmpValue = supplierDetails?.baseInfo ? supplierDetails?.baseInfo?.[column.name] : ''
      if (column.name === 'state' || column.name === 'country') {
        tmpSupplierInfo[column.name] = /^[a-zA-Z\s]+$/.test(tmpValue) ? tmpValue : ''
      } else if (column.name === 'phone') {
        const phone = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : (tmpValue || '')
        // const phone = tmpValue ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : ''
        tmpSupplierInfo.phoneContactId = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
        tmpSupplierInfo[column.name] = !phone ? '' : phone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? phone : supplierDetails?.baseInfo?.['country'] && usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()) && phone.startsWith('1') ? phone : ((supplierDetails?.baseInfo?.['country'] && !usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()))) ? phone : phone.startsWith('1') ? phone : '1 ' + phone
      }
      else if (column.name === 'zip') {
        tmpSupplierInfo[column.name] = /^\d{5}(-\d{4})?$/.test(tmpValue) ? tmpValue : ''
      } else if (column.name === 'email') {
        const email = tmpValue && /^\d+$/.test(tmpValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
        tmpSupplierInfo.emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
        tmpSupplierInfo[column.name] = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email) ? email : ''
        // tmpSupplierInfo[column.name] = tmpValue || ''
      } else if (column.name === 'abbreviatedState') {
        let stateCode = ''
        if (supplierDetails?.baseInfo?.abbreviatedState === null) {
          stateCode = getAbbreviatedState(supplierDetails?.baseInfo?.abbreviatedState, supplierDetails?.baseInfo?.state)
        } else {
          stateCode = supplierDetails?.baseInfo?.abbreviatedState
        }
        tmpSupplierInfo[column.name] = stateCode
      } else {
        tmpSupplierInfo[column.name] = tmpValue
      }
    })
    tmpSupplierInfo["id"] = supplierDetails?.baseInfo?.['id']
    setSupplierInfo(tmpSupplierInfo)
    setSupplierOldInfo(tmpSupplierInfo)
    setAllContacts(supplierDetails?.contacts)
  }, [])

  useEffect(() => {
    if ((!masterSupplierDetails || Object.keys(masterSupplierDetails).length === 0 || masterSupplierDetails?.baseInfo?.['id'] !== masterSupplierId)) {
      return
    }
    if (!masterSupplierColumns) {
      return
    }
    setInitialSupplierInfo(masterSupplierColumns, masterSupplierDetails)
  }, [masterSupplierDetails, masterSupplierColumns, setInitialSupplierInfo])

  useEffect(() => {
    if (Object.values(supplierInfo).length > 0 && !isValidatingPhone) {
      var phoneNumber = !supplierInfo?.['phone'] ? '' : supplierInfo?.['phone']
      handlePhoneNumberFocusOut(null, null, phoneNumber, true, supplierInfo)
      handleEmailFocusOut(supplierInfo?.['email'])
    }
  }, [Object.values(supplierInfo).length])

  const addSupplierBasicInfoHistory = async () => {
    const tmpMasterSupplierDetails = { ...masterSupplierDetails }
    tmpMasterSupplierDetails.baseInfo.phone = /^\d+$/.test(tmpMasterSupplierDetails?.baseInfo?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpMasterSupplierDetails?.baseInfo?.phone) ? tmpMasterSupplierDetails?.contacts?.find(data => data?.id === parseInt(tmpMasterSupplierDetails?.baseInfo?.phone))?.phone : (tmpMasterSupplierDetails?.baseInfo?.phone || '')
    tmpMasterSupplierDetails.baseInfo.email = /^\d+$/.test(tmpMasterSupplierDetails?.baseInfo?.email) ? tmpMasterSupplierDetails?.contacts?.find(data => data?.id === parseInt(tmpMasterSupplierDetails?.baseInfo?.email))?.email : (tmpMasterSupplierDetails?.baseInfo?.email || '')

    supplierInfo['parentOrganization'] = organizationOptions.find(option => option.value === supplierInfo.parentOrganizationId)?.label || null;
    var changeLogNotes = generateSupplierBasicInfoChangeLog(tmpMasterSupplierDetails, supplierInfo);
    if (changeLogNotes !== '') {
      await dispatch(
        await addSupplierHistory({
          supplierId: masterSupplierDetails?.baseInfo?.id,
          note: changeLogNotes,
          noteType: 'changelog'
        })
      )
    }
  }

  const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false, isRetry = false) => {
    var countryCode = (country && country?.dialCode) ? country?.dialCode : ''
    var phoneValueWithCode = phoneValue
    var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
    if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
      setIsPhoneValid(false)
      toast.show({
        title: 'Warning',
        description: 'Please enter valid phone number!'
      })
      return
    }

    if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
      return
    }
    if (phoneValue !== '') {
      setIsValidatingPhone(true)
      phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
      var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch, isRetry)
      setIsPhoneValid(phoneValidationResult?.isPhoneValid)
      setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
    } else {
      setIsPhoneValid(true)
    }
    if (isUseEffect) {
      setSupplierInfo({ ...supplierInfo, 'phone': phoneValidationResult?.phoneNumber })
    }
  }

  const handleEmailFocusOut = async (emailValue, isRetry = false) => {
    if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
      setIsEmailValid(false)
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    if (emailValue && emailValue !== '') {
      setIsValidatingEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
      setIsEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
      setIsEmailRisky(emailValidationResult?.isEmailRisky)
    } else {
      setIsEmailValid(true)
    }
  }

  const handleKeyDown = (e, phoneInputRefname) => {
    if (e.keyCode === 9) {
      phoneInputRefname.current.props.onBlur()
    }
  }

  const parseAddress = async () => {
    if (supplierInfo?.address1) {
      try {
        setIsParsingAddress(true)
        const addressResult = await dispatch(parseFullAddress(supplierInfo?.address1))
        const parsedResult = getParsedAddress(addressResult)
        setSupplierInfo({
          ...supplierInfo,
          'address1': parsedResult?.add1 ? parsedResult?.add1 : '',
          'address2': parsedResult?.add2 ? parsedResult?.add2 : '',
          'city': parsedResult?.city ? parsedResult?.city?.value : '',
          'state': parsedResult?.state ? parsedResult?.state?.value : '',
          'abbreviatedState': parsedResult?.state ? parsedResult?.state?.value : '',
          'country': parsedResult?.country ? parsedResult?.country?.value : '',
          'zip': parsedResult?.zip ? parsedResult?.zip?.value : ''
        })
        setIsParsingAddress(false)
      } catch (err) {
        setIsParsingAddress(false)
      }
    }
  }

  const onContactMouseHover = (event) => {
    const parentWithClass = event.target.closest('.phone-input-parent')
    if (event.target?.dataset?.contactId) {
      const contact = allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
      setCurrentContact(contact ? contact : {})
    } else {
      setCurrentContact({})
    }
    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'block'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'block'
    }
  }

  const onContactMouseHoverOut = (event) => {
    const parentWithClass = event.target.closest('.phone-input-parent')
    if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
      parentWithClass.nextSibling.style.display = 'none'
    } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
      event.target.nextSibling.style.display = 'none'
    }
    setCurrentContact({})
  }

  const onPhoneEmailClick = (type1, type2) => {
    setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false })
    if (type1 === 'email' && !supplierInfo?.emailContactId && supplierInfo?.email?.trim() && supplierInfo?.email?.trim()?.length >= 4) {
      onGetExistingContacts(supplierInfo?.email?.trim(), 'email')
    } else if (type1 === 'phone' && !supplierInfo?.phoneContactId && supplierInfo?.phone?.trim() && supplierInfo?.phone?.trim()?.length >= 4) {
      onGetExistingContacts(supplierInfo?.phone?.trim(), 'phone')
    } else {
      setExistedContacts(allContacts)
    }
  }

  const onPhoneEmailFocusOutClick = () => {
    setShowAllContacts({ ...showAllContacts, email: false, phone: false })
    setExistedContacts(allContacts)
  }

  useEffect(() => {
    if (showAllContacts?.phone && supplierInfo?.phone?.trim() && supplierInfo?.phone?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(supplierInfo?.phone?.trim(), 'phone')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [supplierInfo?.phone])

  useEffect(() => {
    if (showAllContacts?.email && supplierInfo?.email?.trim() && supplierInfo?.email?.trim()?.length >= 4) {
      setIsLoadingExistingContacts(true)
      const delayDebounceFn = setTimeout(async () => {
        onGetExistingContacts(supplierInfo?.email?.trim(), 'email')
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    } else {
      setIsLoadingExistingContacts(false)
    }
  }, [supplierInfo?.email])

  const onGetExistingContacts = (searchValue, type = '') => {
    try {
      setIsLoadingExistingContacts(true)
      dispatch(getExistingContacts({ searchValue, type })).then((res) => {
        if (res?.contacts && res?.contacts?.length > 0) {
          if (masterSupplierDetails?.baseInfo?.['id']) {
            res?.contacts.sort((a, b) => {
              const aContains = a?.supplierIds.includes(masterSupplierDetails?.baseInfo?.['id']) ? 1 : 0;
              const bContains = b?.supplierIds.includes(masterSupplierDetails?.baseInfo?.['id']) ? 1 : 0;
              return bContains - aContains;
            })
          }
          setExistedContacts(res?.contacts)
        } else {
          setExistedContacts([])
        }
        setIsLoadingExistingContacts(false)
      }).catch(() => {
        setExistedContacts([])
        setIsLoadingExistingContacts(false)
      })
    } catch (err) {
      setExistedContacts([])
      setIsLoadingExistingContacts(false)
    }
  }

  const handleContactClick = async (rowData) => {
    const tmpData = { ...supplierInfo }
    if (showAllContacts?.phone) {
      if (!rowData?.phone) {
        toast.show({
          title: 'Warning',
          description: 'No phone number is assigned to this contact!'
        })
        return
      }
      tmpData.phone = rowData?.phone || ''
      tmpData.phoneContactId = rowData?.id || null
      await handlePhoneNumberFocusOut(null, null, tmpData.phone, false)
    }
    if (showAllContacts?.email) {
      if (!rowData?.email) {
        toast.show({
          title: 'Warning',
          description: 'No email is assigned to this contact!'
        })
        return
      }
      tmpData.email = rowData?.email || ''
      tmpData.emailContactId = rowData?.id || null
      await handleEmailFocusOut(tmpData.email)
    }
    setSupplierInfo(tmpData)
    onPhoneEmailFocusOutClick()
    if (rowData) {
      const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
      const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
      if (index === -1) {
        tmpContacts.push(rowData)
      }
      setAllContacts(tmpContacts)
    }
  }

  const handleOnCreateContact = () => {
    let value = ''
    let colName = ''
    if (showAllContacts?.phone) {
      colName = 'phone'
      value = supplierInfo?.phone ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(supplierInfo?.phone) ? `1 ${supplierInfo?.phone}` : supplierInfo?.phone) : ''
    } else {
      colName = 'email'
      value = supplierInfo?.email || ''
    }
    onCreateContact({
      tab: 'basic',
      colName: colName,
      value: value,
      ref: basicInfoSaveRef
    })
    onPhoneEmailFocusOutClick()
  }

  const onCreateContactForEmailPhone = (colName = null, contactId = null, value) => {
    if (colName && contactId) {
      if (colName === 'email') {
        setSupplierInfo({ ...supplierInfo, emailContactId: contactId, email: value })
        setIsEmailValid(true)
        // supplierInfo.emailContactId = contactId
      }
      if (colName === 'phone') {
        setSupplierInfo({ ...supplierInfo, phoneContactId: contactId, phone: value })
        setIsPhoneValid(true)
        // supplierInfo.phoneContactId = contactId
      }
    }
  }

  const onGetContactsData = () => {
    if (showAllContacts?.email) {
      onGetExistingContacts(supplierInfo?.email?.trim(), 'email')
    }
    if (showAllContacts?.phone) {
      onGetExistingContacts(supplierInfo?.phone?.trim(), 'phone')
    }
  }

  const handleRemoveContact = (colName) => {
    if (colName === 'email') {
      setSupplierInfo({ ...supplierInfo, emailContactId: null, email: '' })
      setIsEmailValid(true)
    } else {
      setSupplierInfo({ ...supplierInfo, phoneContactId: null, phone: '' })
      setIsPhoneValid(true)
    }
  }

  const handleCreate = async (inputValue) => {
    if (inputValue === '') {
      toast.show({
        title: 'Warning',
        description: 'Parent Organization cannot be empty!'
      });
      return;
    }
    setIsLoading(true);
    try {
      const response = await dispatch(createParentOrganizations({ value: inputValue })).then((res) => res).catch(err => { if (err) { return {} } });
      const newOption = {
        label: response.name,
        value: response.id,
      };

      setSupplierInfo({
        ...supplierInfo,
        parentOrganizationId: response.id,
        parentOrganization: response.name,
      })

      toast.show({
        title: 'Success',
        description: 'Parent Organization ' + response.name + ' created successfully!'
      });
      setOrganizationOptions((prevOptions) => [...prevOptions, newOption]);
      setSelectedOrganization(newOption);
    } catch (error) {
      console.error('Error creating parent organization:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (columnName, selectedOption) => {
    setSelectedOrganization(selectedOption);
    handleChangeSupplierInfo(columnName, selectedOption?.value)
  };

  return (
    <div className="card supply-information-component mt-5">
      {isLoading && <LoaderComponent />}
      {<Modal
        backdrop={true}
        className="download-file-modal"
        show={showEinModal}
        size="sm"
        onHide={handleCloseEINExistModal}
      >
        <Modal.Header>
          <h3 class="mb-0 fw-bold">Warning</h3>
        </Modal.Header>
        <Modal.Body className='download-file-modal-body'>
          EIN exist with this supplier <Link target="_blank" to={`/suppliers/${supplierExistWithEIN?.id}`}>{supplierExistWithEIN?.suppliername}</Link>
          <h3>On clicking next, we will remove EIN of this list supplier since its already exist</h3>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="modal-download-button" onClick={handleSaveSupplierInfo}><h5 className="mb-0"> Next </h5></button>
          <button type="button" className="modal-upload-button" onClick={handleCloseEINExistModal} ><h5 className="mb-0"> Cancel </h5></button>
        </Modal.Footer>
      </Modal>}
      <div className="card-header flex-column flex-sm-row align-items-start align-items-sm-center pt-2 pb-2 h-auto">
        <h3 className='fw-bold'>Supplier Information</h3>
        <div className="tool d-flex gap-3">
          <button
            type="button"
            className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 cancel-button"
            onClick={handleCancelSupplierInfo}
          >
            Cancel
          </button>
          {isValidatingPhone || isValidatingEmail ? (
            <button
              type="button"
              className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 save-button"
            >
              Validating...
            </button>
          ) : (
            <button
              type="button"
              className="card-edit-button ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 save-button"
              onClick={checkEINExistOrNot}
              ref={basicInfoSaveRef}
            >
              Save
            </button>
          )}
        </div>
      </div>
      <div className="card-content list">
        {
          masterSupplierColumns.map((col, index) => (
            <React.Fragment key={col.name}>
              {
                index === 5 && (
                  <div className="item" key="masterid">
                    <h4 className="label mb-0">Master Supplier Id:</h4>
                    <input
                      className='master-supplier-id'
                      type="text"
                      value={supplierInfo['id'] || ''}
                      disabled={true}
                    />
                  </div>
                )
              }

              {
                index === 4 && (
                  <div className="item" key="parentOrganization">
                    <h4 className="label mb-0">Parent Organization:</h4>
                    <CreatableSelect
                      styles={{
                        container: (baseStyles) => ({
                          ...baseStyles,
                          width: '100%',
                        }),
                        control: (baseStyles) => ({
                          ...baseStyles,
                          fontSize: '16px',
                        }),
                        singleValue: (baseStyles) => ({
                          ...baseStyles,
                          fontSize: '16px',
                        }),
                        placeholder: (baseStyles) => ({
                          ...baseStyles,
                          fontSize: '16px',
                        }),
                        option: (baseStyles) => ({
                          ...baseStyles,
                          fontSize: '16px',
                        }),
                      }}
                      isClearable
                      isLoading={isLoading}
                      onChange={e => handleChange('parentOrganizationId', e)}
                      onCreateOption={handleCreate}
                      options={organizationOptions}
                      value={selectedOrganization}
                      placeholder="Select or create a parent organization"
                      noOptionsMessage={() => "No matching organizations found. Type to create a new one."}
                      formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                      onInputChange={(inputValue) => {
                        if (inputValue.length >= 3) {
                          fetchParentOrganizations(inputValue);
                        }
                      }}
                    />
                  </div>
                )
              }
              <div className="item" key={col.name}>
                <h4 className="label mb-0">{col.label}:</h4>
                {col.name === 'phone' ?
                  <div className={`phone-input-parent flex align-center position-relative${supplierInfo?.phoneContactId ? ' h-100' : ''}`}>
                    <div className={`d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row${supplierInfo?.phoneContactId ? ' input-group flex-wrap align-items-center' : ''}`}>
                      {supplierInfo?.phoneContactId && (
                        <span style={{ width: '35.3px' }} role='button' class='border border-start-0 border-top-0 border-bottom-0 border-dark input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('phone') }}>X</span>
                      )}
                      <input
                        value={supplierInfo[col.name] || ''}
                        className={`basicvalue text-primary border-0 ms-0${supplierInfo?.phoneContactId ? ' w-auto' : ''}`}
                        onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                        onMouseOver={(e) => { onContactMouseHover(e) }}
                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                        data-contact-id={supplierInfo?.phoneContactId || ''}
                        autoComplete='no-phone'
                        onClick={() => { onPhoneEmailClick('phone', 'email') }}
                      />
                      {supplierInfo[col.name] && !showAllContacts?.phone && (
                        <ContactView contact={currentContact} />
                      )}
                      {showAllContacts?.phone && (
                        <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                      )}
                      <div className="input-group phone-extension-container mb-0 flex-nowrap flex-grow-1s">
                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                        <input
                          type="text"
                          className="shadow-none form-control w-auto border-0 ps-3 pe-3"
                          placeholder="phone ext."
                          value={supplierInfo['phoneExtension'] || ''}
                          onChange={e => handleChangeSupplierInfo('phoneExtension', e.target.value)}
                          disabled={(!supplierInfo['phone'] || !isPhoneValid || supplierInfo['phone'] === countryCode) ? true : false}
                        />
                      </div>
                    </div>
                    {isValidatingPhone && (<Loader />)}

                    {supplierInfo[col.name] && !isValidatingPhone && isPhoneValid !== '' &&
                      (isPhoneValid ?
                        <BsCheckSquare color="#067911" size={26} />
                        :
                        <>
                          <BsXSquare color="#f75a52" size={26} />
                          {/* {supplierInfo?.phoneContactId && (
                            <MdOutlineChangeCircle
                              title='Retry'
                              role='button'
                              color="#14438b"
                              size={30}
                              onClick={() => { handlePhoneNumberFocusOut(null, null, supplierInfo[col.name], false, true) }}
                            />
                          )} */}
                        </>
                      )
                    }
                  </div>
                  :
                  col.name === 'email' ?
                    <>
                      <div className={`phone-input-parent flex align-center position-relative${supplierInfo?.emailContactId ? ' input-group h-100 align-items-center' : ''}`}>
                        {supplierInfo?.emailContactId && (
                          <span role='button' class='border-dark border-end-0 input-group-text text-red px-3 fs-2 fw-bold h-100 mb-0' onClick={() => { handleRemoveContact('email') }}>X</span>
                        )}
                        <input
                          role='button'
                          style={{ marginLeft: supplierInfo?.emailContactId ? '-10px' : '0' }}
                          className={`basicvalue text-primary form-control${supplierInfo?.emailContactId ? ' w-auto' : ''}`}
                          type="text"
                          value={supplierInfo[col.name] || ''}
                          onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                          // onBlur={() => { isEmailValid === '' && handleEmailFocusOut(supplierInfo[col.name]) }}
                          onMouseOver={(e) => { onContactMouseHover(e) }}
                          onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                          autoComplete='no-email'
                          data-contact-id={supplierInfo?.emailContactId || ''}
                          onClick={() => { onPhoneEmailClick('email', 'phone') }}
                        />
                        {supplierInfo[col.name] && !showAllContacts?.email && (
                          <ContactView contact={currentContact} />
                        )}
                        {showAllContacts?.email && (
                          <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={masterSupplierDetails?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                        )}
                        {isValidatingEmail && (<Loader />)}
                        {supplierInfo[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                          (isEmailRisky ?
                            <BsCheckSquare color="#EFD700 " size={26} />
                            : isEmailValid ?
                              <BsCheckSquare color="#067911" size={26} />
                              :
                              <>
                                <BsXSquare color="#f75a52" size={26} />
                                {/* {supplierInfo?.emailContactId && (
                                  <MdOutlineChangeCircle
                                    title='Retry'
                                    role='button'
                                    color="#14438b"
                                    size={30}
                                    onClick={() => { handleEmailFocusOut(supplierInfo[col.name], true) }}
                                  />
                                )} */}
                              </>
                          )
                        }
                      </div>
                    </>
                    :
                    <div className={`w-100 ${col.name === 'address1' ? 'd-flex gap-3 h-100' : ''}`}>
                      <input
                        className={`basicvalue ${col.name === 'phone' ? !isPhoneValid ? 'failed' : '' : ''} ${col.name === 'zip' ? 'supplier-zip-input' : ''} ${col.name === 'country' ? 'supplier-country-input' : ''}`}
                        type="text"
                        value={supplierInfo[col.name] || ''}
                        onChange={e => handleChangeSupplierInfo(col.name, e.target.value, e)}
                      />
                      {col.name === 'address1' && supplierInfo?.address1 && (
                        <div className="position-relative text-center h-100">
                          {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                          <button
                            type="button"
                            className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 bg-dark-blue rounded text-white`}
                            onClick={parseAddress}
                          >
                            Parse Address
                          </button>
                        </div>
                      )}
                    </div>
                }
              </div>
            </React.Fragment>
          ))
        }
      </div>
    </div >
  )
})

export default SupplyInformation